class KeywordDictionary {
  constructor () {
    this.data = null
  }

  init( postsData ) {
    this.data = postsData
  }

  getWord( keyword ){
    for (let i = 0; i < this.data.length; ++i) {
      const post = this.data[i]
      // console.log(post.title.rendered.toLowerCase(), keyword.toLowerCase())
      if(post.title.rendered.toLowerCase() == keyword.toLowerCase()){
        return post.content.rendered
      }
    }
    return 'Sanaa ('+ keyword +') ei löytynyt.'
  }
}

const keywordDictionary = new KeywordDictionary()

export default keywordDictionary



// WEBPACK FOOTER //
// ./src/utils/dictionary.js